import { AssemblyPhase } from './panels/AssemblyPhase';
import { SubphaseId } from './phaseBusy';
import { PhaseControls } from './PhaseControls';
import { ASSEMBLY_CALL_SLOT_ID } from './assemblySlot';

// THE ASSEMBLY PHASE: one animation per sub-step.
//
// IT HAD A JOINTS SUBPHASE, each hardware joint played by its holes alone and signed off, which
// wrote those movements over the sub-steps'. The sub-steps' own rules (joint, set, hole, tool) are
// what the phase plays now, and that sign-off could only overwrite them with less.
//
// THE COVERS HAVE NO SUBPHASE OF THEIR OWN EITHER. Placing a wood button over a screw is a sub-step
// of the manual like the screw before it, and it is placed where the manual does it: in the assembly
// sub-steps, by the sub-step that puts it on, and by rule — on the hole its screw enters by, under
// the foot (see fromHole).
export function AssemblySubphases({ docId }: { docId: string }) {
  return (
    // EVERYTHING HERE IS THE SUBPHASE'S, its card hatched while its badges spin (see phaseBusy).
    <SubphaseId.Provider value="animations">
    <div className="flex flex-col gap-6">
      {/* THE PHASE'S CALLS, over the sub-steps as every phase's are — the sub-step on screen's,
          drawn here by it (see AssemblyPhase). */}
      <PhaseControls>
        <span id={ASSEMBLY_CALL_SLOT_ID} className="contents" />
      </PhaseControls>
      <AssemblyPhase docId={docId} />
    </div>
    </SubphaseId.Provider>
  );
}
